// Module
var code = "<ng-transclude> <select ng-model=\"vm.model\" ng-options=\"option for option in vm.options\"> <option value=\"\">Select</option> </select> </ng-transclude> ";
// Exports
module.exports = code;